import axios from "axios";

import { LMS_TOKEN } from "../../../../utils/cookiesmanager";

import { LMS_BASE_URL } from "../../../../utils/http/http-common";

export const getModuleListApiCall = async ({ courseId ,languageId  = 1 }) => {
  const token = localStorage.getItem(LMS_TOKEN);
  try {
    const response = await axios.get(
      `${LMS_BASE_URL}/course/module/${courseId}?languageId=${languageId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const updateEnrollNowApiCall = async (payload) => {
  const authToken = localStorage.getItem(LMS_TOKEN);

  try {
    const response = await axios.post(
      `${LMS_BASE_URL}/course/enroll`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
